import React from "react";
import { Box, Typography } from "@mui/material";
import BlinkoButton from "../Button/Button.component";
import { l } from "../../libs/localization";
import usePermissions from "../../hooks/usePermissions";
import { getFromLocalStorage } from "../../libs/helpers/localstorage";
import { pricingPageUrls } from "../../pages/profile/subscriptionInfo.page";
import { helpdeskEmails } from "../ContactSalesModal/ContactSalesModal.component";

// Renders inside a table's body (via antd Table's `locale.emptyText`) when
// the tenant's plan doesn't include this data. Real columns/filters stay
// visible above it — we deliberately never fabricate rows here, since we
// don't actually know whether this specific record has data or not, and a
// fake row would misrepresent that as a real answer.
export default function GatedTableEmptyState({ message }) {
  const permissions = usePermissions();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const pricingUrl = pricingPageUrls[tenant];
  const canUpgrade = permissions.ecommerce && !!pricingUrl;
  const href = canUpgrade
    ? pricingUrl
    : `mailto:${helpdeskEmails[tenant] || helpdeskEmails.italy}`;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        boxSizing: "border-box",
        backgroundColor: "#fff",
        borderRadius: "10px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        py: 5,
        px: 3,
      }}
    >
      <Typography sx={{ mb: 2.5, textAlign: "center", color: "#565551" }}>
        {message || l("ECOMMERCE.GATED_TABLE_DEFAULT_MESSAGE")}
      </Typography>
      <a href={href}>
        <BlinkoButton thin sx={{ px: 6 }}>
          {canUpgrade ? l("ECOMMERCE.CHOOSE_PLAN") : l("ECOMMERCE.CONTACT")}
        </BlinkoButton>
      </a>
    </Box>
  );
}
